"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var React = require("react");
var styles = require("./Icon.scss");
/* tslint:enable */
var Icon_Props_1 = require("./Icon.Props");
var Image_1 = require("../Image/Image");
var Utilities_1 = require("../../Utilities");
exports.Icon = function (props) {
    var customIcon = props.iconName === 'None';
    var iconClassName = props.iconName ? ('ms-Icon--' + props.iconName) : '';
    if (props.iconType === Icon_Props_1.IconType.image || props.iconType === Icon_Props_1.IconType.Image) {
        var containerClassName = Utilities_1.css('ms-Icon', 'ms-Icon-imageContainer', styles.imageContainer, props.className);
        return (React.createElement("div", { className: containerClassName },
            React.createElement(Image_1.Image, __assign({}, props.imageProps))));
    }
    else {
        var className = Utilities_1.css('ms-Icon', customIcon ? '' : iconClassName, props.className);
        return React.createElement("i", __assign({}, Utilities_1.getNativeProps(props, Utilities_1.htmlElementProperties), { className: className }));
    }
};

//# sourceMappingURL=Icon.js.map



//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/Icon/Icon.js
// module id = 247
// module chunks = 0